module.exports = __webpack_public_path__ + "img/chevron-right-gray.4be2bc7a.svg";